/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled, { css } from 'styled-components';

/**
 * Estilização da div
 */
export default styled.div`
  background-color: ${({ theme }) => theme.primaryColorDark};
  height: 42px;
  color: white;
  padding-left: 260px;
  justify-content: center;
  display: flex;
  position: relative;

  .main-tools {
    display: flex;
    flex: 1;
    justify-content: center;
  }

  .permanent-tools {
    display: flex;
    margin: 0 20px;
    button {
      margin: 0 0;
    }
    .MuiSkeleton-circle {
      margin: 13px 7px;
    }
  }

  .MuiSkeleton-circle {
    height: 16px;
    width: 16px;
    margin: 13px;
    background-color: rgba(255, 255, 255, 0.11);
  }

  button {
    background: none;
    border: none;
    margin: 0 4px;
    flex: 0 0 auto;
    color: ${({ theme }) => theme.icons};
    &.active {
      /* color: #3c71dd; */
      border-bottom: solid 3px ${({ theme }) => theme.primaryColor};
      border-top: solid 3px transparent;
    }
    &:hover {
      border-bottom: solid 3px ${({ theme }) => theme.primaryColor};
      border-top: solid 3px transparent;
    }
    &:disabled {
      color: #c3c3c3;
    }
  }

  .spacer {
    width: 15px;
  }

  @media (max-width: 768px) {
    display: ${({ isHided }) => (isHided ? 'none' : 'flex')};
    padding: 0;
    background: none;
    min-width: 100px;
    position: fixed;
    z-index: 1150;
    top: 0;
    right: 50px;
    justify-content: flex-start;
    flex-direction: row;
    width: calc(100% - 140px);
    overflow-x: auto;
  }
`;

/**
 * Estilização do componente animation
 */
const animation = css`
  animation: slide 0.5s forwards;
  @keyframes slide {
    0% {
      transform: translateY(0px);
      opacity: 0 !important;
    }
    50% {
      transform: translateY(50px);
    }
    100% {
      transform: translateY(0px);
      opacity: 1 !important;
    }
  }
`;

/**
 * Estilização do componente MobileToolsConfiguration
 */
export const MobileToolsConfiguration = styled.div`
  position: fixed;
  bottom: 0px;
  right: 0px;
  left: 0px;
  z-index: 1500;
  ${({ show }) => (show ? animation : '')}

  .react-swipeable-view-container {
    border-radius: 6px 6px 0px 0px;
    box-shadow: none !important;

    > div {
      border-radius: 6px 6px 0px 0px;
      padding: 25px 24px;
      background: white;
    }
  }
`;

/**
 * Estilização do componente MobileToolsTitle
 */
export const MobileToolsTitle = styled.div`
  position: fixed;
  z-index: 1500;
  height: 56px;
  overflow: hidden;
  display: flex;
  margin-bottom: 10px;

  h1 {
    padding: 16px 16px 16px 0;
    margin: 0;
    color: ${({ theme }) => theme.icons};
    font-weight: 300;
    font-size: 16px;
    line-height: 19px;
  }

  > button {
    background: none;
    border: none;
    padding: 16px;

    svg {
      path {
        fill: ${({ theme }) => theme.icons};
      }
    }
  }
`;
